import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import classnames from 'classnames';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var breakpoint = function breakpoint(_breakpoint) {
  return breakpoints[_breakpoint];
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var internalPaddingRegular = '\n    overflow: auto;\n    padding-left: ' + spacing.DOUBLE + ';\n    padding-top: ' + spacing.DOUBLE + ';\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint$1 in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint$1)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint$1],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint$1], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var main = "Accordion.js";
var deprecations = [{
	replacements: {
		name: "GenericAccordion",
		path: "Layout/Content/Accordions"
	}
}];
var packageJson = {
	main: main,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations
};

var Accordion = function (_Component) {
	inherits(Accordion, _Component);

	function Accordion(props) {
		classCallCheck(this, Accordion);

		var _this = possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

		_this.state = {
			expanded: props.expanded
		};
		_this.handleClick = _this.handleClick.bind(_this);
		return _this;
	}

	createClass(Accordion, [{
		key: 'handleClick',
		value: function handleClick(index) {
			this.setState({
				expanded: index
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var expanded = this.state.expanded;
			var children = this.props.children;


			var expandedIsArray = Array.isArray(expanded);
			var newexpanded = expandedIsArray ? expanded : [expanded];

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson, hasCustomMargins: true },
				React.createElement(
					'div',
					{ className: 'c-m-accordion' },
					React.Children.map(children, function (item, index) {
						return React.cloneElement(item, {
							collapsed: newexpanded.indexOf(index) === -1,
							isOpen: newexpanded.indexOf(index) !== -1,
							key: 'accordion-item-' + index,
							onClick: function onClick() {
								return _this2.handleClick(index);
							}
						});
					})
				)
			);
		}
	}]);
	return Accordion;
}(Component);

Accordion.propTypes = {
	/** Accordion takes either AccordionItem or AccordionTable children. */
	children: PropTypes.node,
	/** Allow configuration of expand children are expanded. */
	expanded: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ width: "96", height: "96", viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48 62.862l39.413-40.354a4.972 4.972 0 0 1 7.114 0l.144.148a5 5 0 0 1 0 6.988L51.845 73.492A4.96 4.96 0 0 1 48 74.982a4.959 4.959 0 0 1-3.845-1.49L1.329 29.644a5 5 0 0 1 0-6.988l.144-.148a4.972 4.972 0 0 1 7.114 0L48 62.862z" }));
});

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M48.799 76.174a7.134 7.134 0 0 1-5.06-2.097L.8 31.137l10.12-10.12 37.88 37.88 37.88-37.88 10.12 10.12-42.94 42.94a7.134 7.134 0 0 1-5.06 2.097z" }));
});

var getChevronDownSolidLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var main$1 = "AccordionItem.js";
var deprecations$1 = [{
	replacements: {
		name: "GenericAccordion",
		path: "Layout/Content/Accordions"
	}
}];
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$1
};

var _templateObject$5 = taggedTemplateLiteral(['\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n'], ['\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t.c-m-accordion__title {\n\t\tfont-family: ', ' !important;\n\t\t-webkit-font-smoothing: antialiased;\n\t}\n'], ['\n\tcolor: ', ';\n\t.c-m-accordion__title {\n\t\tfont-family: ', ' !important;\n\t\t-webkit-font-smoothing: antialiased;\n\t}\n']);

var StyledIconWrapper = styled('div')(_templateObject$5, function (props) {
	return props.theme.name === 'vm' ? props.theme.colours.interaction : props.theme.colours.bodyText;
}, function (props) {
	return !props.collapsed && 'transform: rotate(180deg)';
});

var StyledWrapper$1 = styled('div')(_templateObject2$4, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.theme.fonts.display.bold;
});

var AccordionItem = function (_Component) {
	inherits(AccordionItem, _Component);

	function AccordionItem(props) {
		classCallCheck(this, AccordionItem);

		var _this = possibleConstructorReturn(this, (AccordionItem.__proto__ || Object.getPrototypeOf(AccordionItem)).call(this, props));

		var collapsed = props.collapsed;

		_this.state = {
			collapsed: collapsed
		};
		return _this;
	}

	createClass(AccordionItem, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    scrollable = _props.scrollable,
			    title = _props.title,
			    onClick = _props.onClick,
			    theme = _props.theme;
			var collapsed = this.state.collapsed;


			var collapseHandler = function collapseHandler(onClick) {
				return function () {
					return _this2.setState({
						collapsed: !_this2.state.collapsed
					}, onClick);
				};
			};

			var iconClassNames = classnames('c-m-accordion__control', {
				'c-m-accordion__control--open': !collapsed
			});

			var ChevronDownIcon = getChevronDownSolidLarge(theme.name);

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$1, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$1,
					null,
					React.createElement(
						'div',
						{ className: 'c-m-accordion__item' },
						React.createElement(
							'div',
							{
								role: 'button',
								tabIndex: '0',
								className: 'c-m-accordion__header u-faux-block-link',
								onClick: collapseHandler(onClick),
								onKeyUp: collapseHandler(onClick)
							},
							React.createElement(
								'div',
								{ className: 'c-m-accordion__title' },
								title,
								React.createElement(
									StyledIconWrapper,
									{ className: iconClassNames, collapsed: collapsed },
									React.createElement(ChevronDownIcon, null)
								)
							)
						),
						!collapsed && React.createElement(
							'div',
							{ className: 'c-m-accordion__body' },
							React.createElement(
								'div',
								{
									className: classnames('c-m-accordion__content', {
										'c-m-accordion__content--overflow-scroll': scrollable
									})
								},
								children
							)
						)
					)
				)
			);
		}
	}]);
	return AccordionItem;
}(Component);

AccordionItem.propTypes = {
	/** Makes up the content within the accordion item. Typically body copy. */
	children: PropTypes.node,
	/** Defines whether accordion item is collapsed or expanded initially. */
	collapsed: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func,
	/** Controls whether the content within the accordion item is fluid or scrollable. */
	scrollable: PropTypes.bool,
	/** This will appear in the header. */
	title: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

AccordionItem.defaultProps = {
	collapsed: true
};

var WrappedAccordionItem = withTheme(AccordionItem);

var main$2 = "StandardLabel.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledStandardLabel = styled('div')(_templateObject$6, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush, 'data-test-id': dataTestId, id: id },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String id passed to underlying html element. */
	id: PropTypes.string
};

StandardLabel.defaultProps = {
	isFlush: false,
	'data-test-id': 'standard-label'
};

var main$3 = "Table.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "outdated",
	"is-bespoke": false
};

var getBasicLayoutStyles = function getBasicLayoutStyles(theme) {
	return '\n\tborder-radius: ' + theme.borderRadius + ';\n\tmargin-bottom: ' + (theme.isCompact ? '0' : '2rem') + ';\n\toverflow: hidden;\n\n    table {\n\t\tbackground: ' + colours.generalPalette.white + ';\n\t\tborder-collapse: collapse;\n        margin-bottom: 0;\n        width: 100%;\n    }\n\n    th {\n\t\tborder: none;\n\t\tborder-bottom: 1px solid ' + theme.colours.bodyText + ';\n\t\ttext-align: left;\n        vertical-align: middle;\n    }\n\n    td {\n\t\tborder: none;\n\t\tborder-bottom: 1px solid #d1d1d1;\n    }\n\n    tbody {\n        tr:last-child {\n            td {\n                border: none;\n            }\n        }\n    }\n';
};

var getBasicLayoutWithBrandedStyles = function getBasicLayoutWithBrandedStyles(theme) {
	return '\n\tborder: 2px solid ' + theme.colours.tableHeader + ';\n\n    thead tr {\n        background: ' + theme.colours.tableHeader + ';\n        color: ' + colours.generalPalette.white + ';\n\t}\n\n\tth {\n\t\tborder-bottom: 0;\n\t}\n';
};

var getHorizontalLayoutStyles = function getHorizontalLayoutStyles(theme, customBreakpoint) {
	return '\n\tborder: 1px solid #d1d1d1;\n\tborder-radius: ' + theme.borderRadius + ';\n\toverflow: hidden;\n\n\ttable {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tborder-collapse: collapse;\n\t\tcolor: ' + theme.colours.bodyText + ';\n\t\tmargin-bottom: 0;\n\t\twidth: 100%;\n\t}\n\n\tthead {\n\t\ttext-align: left;\n\t}\n\n\tth {\n\t\tborder: none;\n\t\tbackground-color: ' + colours.component.tableHeader + ';\n\t\tpadding: 8px;\n\t}\n\n\ttbody {\n\t\ttext-align: left;\n\t}\n\n\ttr {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tpadding: 8px 48px 8px 0;\n\t\ttext-align: left;\n\t\tvertical-align: top;\n\t\t&:nth-child(even) {\n\t\t\tbackground-color: ' + colours.component.tableCell + ';\n\t\t}\n\n\t\t@media (min-width: ' + customBreakpoint + 'px) {\n\t\t\tbackground-image: none;\n\t\t\tpadding: 8px 0;\n\t\t}\n\t}\n\n\ttd {\n\t\tborder: none;\n\t\tpadding: 8px;\n\t\ttext-align: left;\n\t}\n}';
};

var getHorizontalLayoutWithBrandedStyles = function getHorizontalLayoutWithBrandedStyles(theme) {
	return '\n\tborder-color: ' + theme.colours.tableHeader + ';\n\n\tth {\n\t\tbackground-color: ' + theme.colours.tableHeader + ';\n\t\tcolor: ' + colours.generalPalette.white + ';\n\n\t\t&.c-m-horizontal-table__feature-cell {\n\t\t\tbackground-color: ' + theme.colours.tableHeader + ';\n\t\t}\n\t}\n\n\ttr {\n\t\t&:nth-child(even) {\n\t\t\tbackground-color: ' + theme.colours.tableAccent + ';\n\t\t}\n\t}\n}';
};

var getTransactionsLayoutStyles = function getTransactionsLayoutStyles(theme, customBreakpoint) {
	return '\n\tborder: 1px solid ' + colours.generalPalette.greyLightest + ';\n\tborder-radius: $global-radius;\n\toverflow: hidden;\n\n\ttable {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tborder-collapse: collapse;\n\t\tcolor: ' + theme.colours.bodyText + ';\n\t\tmargin-bottom: 0;\n\t}\n\n\tthead {\n\t\ttr {\n\t\t\tbackground-color: ' + colours.component.tableHeader + ';\n\t\t\tcolor: ' + theme.colours.bodyText + ';\n\t\t}\n\t}\n\n\tth {\n\t\tbackground-color: transparent;\n\t\tborder: none;\n\t\tfont-weight: normal;\n\t\ttext-align: left;\n\t\tvertical-align: middle;\n\t\twhite-space: normal;\n\n\t\t@media (min-width: ' + customBreakpoint + 'px) {\n\t\t\tpadding: 16px;\n\t\t}\n\t}\n\n\ttbody {\n\t\ttext-align: left;\n\n\t\ttr {\n\t\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: ' + colours.component.tableCell + ';\n\t\t\t}\n\t\t}\n\t}\n\n\ttr {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tpadding: 8px 0;\n\t\ttext-align: left;\n\t\tvertical-align: top;\n\n\t\t@media (min-width: ' + customBreakpoint + 'px) {\n\t\t\tbackground-image: none;\n\t\t}\n\t}\n\n\ttd {\n\t\tborder: 0;\n\t\tpadding: 8px;\n\t\ttext-align: left;\n\t\t&:before {\n\t\t\tflex: 2;\n\t\t\tpadding-right: 16px;\n\t\t}\n\n\t\t> * {\n\t\t\tflex: 3;\n\t\t}\n\n\t\t@media (min-width: ' + customBreakpoint + 'px) {\n\t\t\tborder: none;\n\t\t\tpadding: 16px;\n\t\t}\n\t}\n';
};

var getTransactionsLayoutWithBrandedStyles = function getTransactionsLayoutWithBrandedStyles(theme) {
	return '\n\tborder-color: ' + theme.colours.tableHeader + ';\n\n\tthead {\n\t\ttr {\n\t\t\tbackground-color: ' + theme.colours.tableHeader + ';\n\t\t\tcolor: ' + colours.generalPalette.white + ';\n\t\t}\n\n\t\t.c-a-button .c-a-button__title {\n\t\t\tcolor: ' + colours.generalPalette.white + ';\n\t\t}\n\t}\n\n\ttbody {\n\t\ttr {\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: ' + theme.colours.tableAccent + ';\n\t\t\t}\n\t\t}\n\t}\n';
};

var getVerticalLayoutStyles = function getVerticalLayoutStyles(theme, customBreakpoint) {
	return '\n\tborder-radius: ' + theme.borderRadius + ';\n\tborder: 1px solid ' + colours.generalPalette.greyLightest + ';\n\toverflow: hidden;\n\n\ttable {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tborder-collapse: collapse;\n\t\tcolor: ' + theme.colours.bodyText + ';\n\t\tmargin-bottom: 0;\n\t\twidth: 100%;\n\t}\n\n\tthead {\n\t\ttext-align: left;\n\t}\n\n\tth {\n\t\tborder: none;\n\t\tbackground-color: ' + colours.component.tableHeader + ';\n\t\tbox-sizing: border-box;\n\t\tpadding: 8px;\n\n\t\t&.c-m-vertical-table__feature-cell {\n\t\t\tbackground-color: ' + colours.component.tableHeader + ';\n\t\t}\n\t}\n\n\ttbody {\n\t\ttext-align: left;\n\t}\n\n\ttr {\n\t\tbackground-color: ' + colours.generalPalette.white + ';\n\t\tpadding: 8px 48px 8px 0;\n\t\ttext-align: left;\n\t\tvertical-align: top;\n\n\t\t&:nth-child(even) {\n\t\t\tbackground-color: ' + colours.component.tableCell + ';\n\t\t}\n\n\t\t@media (min-width: ' + customBreakpoint + 'px) {\n\t\t\tbackground-image: none;\n\t\t\tpadding: 8px 0;\n\t\t}\n\t}\n\n\ttd {\n\t\tborder: none;\n\t\tpadding: 8px;\n\t\ttext-align: left;\n\t}\n}';
};

var getVerticalLayoutWithBrandedStyles = function getVerticalLayoutWithBrandedStyles(theme) {
	return '\n\tborder-color: ' + theme.colours.tableHeader + ';\n\n\tth {\n\t\tbackground-color: ' + theme.colours.tableHeader + ';\n\t\tcolor: ' + colours.generalPalette.white + ';\n\n\t\t&.c-m-vertical-table__feature-cell {\n\t\t\tbackground-color: ' + theme.colours.tableHeader + ';\n\t\t}\n\t}\n\n\ttr {\n\t\t&:nth-child(even) {\n\t\t\tbackground-color: ' + theme.colours.tableAccent + ';\n\t\t}\n\t}\n\n\ttd {\n\t\t&.c-m-vertical-table__feature-cell {\n\t\t\tbackground-color: ' + theme.colours.primary + ';\n\t\t\tcolor: ' + colours.generalPalette.white + ';\n\t\t}\n\t}\n';
};

var _templateObject$7 = taggedTemplateLiteral(['\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n'], ['\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n\n\t', '}\n\t', '}\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledWrapper$2 = styled('div')(_templateObject$7, function (props) {
	return props.hasBasicLayout && getBasicLayoutStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasBasicLayout && props.hasBrandedStyle && getBasicLayoutWithBrandedStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasHorizontalLayout && getHorizontalLayoutStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasHorizontalLayout && props.hasBrandedStyle && getHorizontalLayoutWithBrandedStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasTransactionsLayout && getTransactionsLayoutStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasTransactionsLayout && props.hasBrandedStyle && getTransactionsLayoutWithBrandedStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasVerticalLayout && getVerticalLayoutStyles(props.theme, props.customBreakpoint);
}, function (props) {
	return props.hasVerticalLayout && props.hasBrandedStyle && getVerticalLayoutWithBrandedStyles(props.theme, props.customBreakpoint);
});

var StyledTable = styled('table')(_templateObject2$5, function (props) {
	return props.isResponsive && '\n\t\tborder-collapse: collapse;\n\t\tline-height: 1.2;\n\t\twidth: 100%;\n\n\t\tcaption {\n\t\t\tposition: relative;\n\t\t}\n\n\t\tthead {\n\t\t\tdisplay: none;\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tdisplay: table-row-group;\n\t\t\t}\n\t\t}\n\n\t\tth {\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tdisplay: table-cell;\n\t\t\t\tpadding: ' + (props.theme.isCompact ? '8px' : '16px') + ';\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\tdisplay: block;\n\t\t\twhite-space: normal;\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tdisplay: table-row-group;\n\t\t\t}\n\t\t}\n\n\t\ttr {\n\t\t\tdisplay: block;\n\t\t\tpadding: 8px 0;\n\t\t\twhite-space: normal;\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tdisplay: table-row;\n\t\t\t}\n\t\t}\n\n\t\ttd {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tpadding: 8px;\n\t\t\twhite-space: normal;\n\n\t\t\t&:before {\n\t\t\t\tcontent: attr(data-title);\n\t\t\t\tflex: 1;\n\t\t\t\tpadding-right: 16px;\n\t\t\t}\n\n\t\t\t> * {\n\t\t\t\tflex: 2;\n\t\t\t}\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tborder: 1px solid inherit;\n\t\t\t\tdisplay: table-cell;\n\t\t\t\tpadding: ' + (props.theme.isCompact ? '8px' : '16px') + ';\n\n\t\t\t\t&:before {\n\t\t\t\t\tcontent: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.o-responsive-table__cell-tag {\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\n\t\t\t.c-a-icon {\n\t\t\t\theight: 16px;\n\t\t\t\tmargin-right: 8px;\n\t\t\t\twidth: 16px;\n\t\t\t}\n\t\t}\n\n\t\t.o-responsive-table__faux-action {\n\t\t\tmargin-top: -8px;\n\t\t\tposition: absolute;\n\t\t\tright: 16px;\n\t\t\ttop: 50%;\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t.c-a-icon {\n\t\t\t\theight: 24px;\n\t\t\t\twidth: 24px;\n\t\t\t}\n\t\t}\n\n\t\ta.u-faux-block-link__overlay {\n\t\t\tposition: static;\n\n\t\t\t@media (min-width: ' + props.customBreakpoint + 'px), print {\n\t\t\t\tposition: relative;\n\t\t\t}\n\t\t}\n  \t';
});

var Table = function Table(_ref) {
	var breakpointSnap = _ref.breakpointSnap,
	    children = _ref.children,
	    isBranded = _ref.isBranded,
	    layout = _ref.layout;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$2,
			{
				customBreakpoint: breakpointSnap,
				hasBasicLayout: layout === 'basic',
				hasHorizontalLayout: layout === 'horizontal',
				hasTransactionsLayout: layout === 'transactions',
				hasVerticalLayout: layout === 'vertical',
				hasBrandedStyle: isBranded
			},
			React.createElement(
				StyledTable,
				{ customBreakpoint: breakpointSnap, isResponsive: layout !== 'horizontal' && layout !== 'vertical' },
				children
			)
		)
	);
};

Table.propTypes = {
	/** Supplying this will override the default breakpoint where the table snaps to card view. */
	breakpointSnap: PropTypes.oneOf(['480', '640', '960', '1280']),
	/** Table children as nodes. */
	children: PropTypes.node,
	/** A choice of table layouts. */
	layout: PropTypes.oneOf(['basic', 'horizontal', 'vertical', 'transactions']),
	/** Boolean controlling the applicatin of branded styles. */
	isBranded: PropTypes.bool
};

Table.defaultProps = {
	breakpointSnap: '960',
	isBranded: false,
	layout: 'basic'
};

var TableBody = function TableBody(_ref) {
	var children = _ref.children;
	return React.createElement(
		'tbody',
		null,
		children
	);
};

TableBody.propTypes = {
	children: PropTypes.node
};

var _templateObject$8 = taggedTemplateLiteral(['\n\t', ';\n\n\t', ';\n\n\t&.barrelroll-TableBodyData {\n\t\t', ';\n\t}\n\n\t', ';\n'], ['\n\t', ';\n\n\t', ';\n\n\t&.barrelroll-TableBodyData {\n\t\t', ';\n\t}\n\n\t', ';\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\t', ';\n\n\t', ';\n'], ['\n\t', ';\n\n\t', ';\n']);

var getCellPaddingOverrides = function getCellPaddingOverrides(hasContent, hasSlotPadding) {
	if (!hasContent) {
		return 'padding: 0 !important;';
	}

	if (hasSlotPadding) {
		return internalPaddingRegular + ' padding-bottom: 0; padding-right: 0;';
	}

	return '';
};

var StyledWrapper$3 = styled('td')(_templateObject$8, function (props) {
	return props.isFeatured && props.hasAlignment && '\n\t\tbackground-color: ' + colours.component.tableHeader + ';\n\t\tcolor: ' + props.theme.colours.bodyText + ';\n\t\twidth: 1%;\n\n\t\t* {\n\t\t\twhite-space: nowrap;\n\t\t}\n\t';
}, function (props) {
	return props.isFeatured && props.layout === 'vertical' && '\n\t\tbackground-color: ' + props.theme.colours.tableHeader + ';\n\t\tcolor: ' + colours.generalPalette.white + ';\n\t';
}, function (_ref) {
	var hasContent = _ref.hasContent,
	    hasSlotPadding = _ref.hasSlotPadding;
	return getCellPaddingOverrides(hasContent, hasSlotPadding);
}, function (props) {
	return props.isHiddenForPrint && '@media print {\n\t\t\tdisplay: none!important;\n\t\t};';
});

var StyledCell = styled('div')(_templateObject2$6, function (props) {
	return props.alignment === 'right' && '\n\t\t@media (min-width: ' + props.breakpoint + 'px) {\n\t\t\ttext-align: right;\n\t\t}\n\t';
}, function (props) {
	return props.alignment === 'center' && '\n\t\t@media (min-width: ' + props.breakpoint + 'px) {\n\t\t\ttext-align: center;\n\t\t}\n\t';
});

var TableBodyData = function TableBodyData(_ref2) {
	var children = _ref2.children,
	    customBreakpoint = _ref2.customBreakpoint,
	    alignment = _ref2.alignment,
	    isFeatureCell = _ref2.isFeatureCell,
	    layout = _ref2.layout,
	    title = _ref2.title,
	    isHiddenForPrint = _ref2.isHiddenForPrint;
	return React.createElement(
		StyledWrapper$3,
		{
			'data-title': children && title,
			hasContent: !!children,
			isFeatured: isFeatureCell,
			layout: layout,
			hasAlignment: layout === 'horizontal' || layout === 'vertical',
			hasSlotPadding: alignment === 'slot',
			className: 'barrelroll-TableBodyData' // TODOxVM: Remove hack to defeat cascade.
			, isHiddenForPrint: isHiddenForPrint
		},
		React.createElement(
			StyledCell,
			{ alignment: alignment, breakpoint: customBreakpoint },
			children
		)
	);
};

TableBodyData.propTypes = {
	alignment: PropTypes.oneOf(['left', 'right', 'center', 'slot']),
	children: PropTypes.node,
	customBreakpoint: PropTypes.oneOf(['480', '640', '960', '1280']),
	isFeatureCell: PropTypes.bool,
	layout: PropTypes.oneOf(['horizontal', 'vertical']),
	title: PropTypes.string,
	isHiddenForPrint: PropTypes.bool
};

TableBodyData.defaultProps = {
	alignment: 'left',
	customBreakpoint: '960',
	isHiddenForPrint: false
};

var _templateObject$9 = taggedTemplateLiteral(['\n\ttd {\n\t\t', ';\n\n\t\t', ';\n\t}\n'], ['\n\ttd {\n\t\t', ';\n\n\t\t', ';\n\t}\n']);

var StyledWrapper$4 = styled('tr')(_templateObject$9, function (props) {
	return props.isVerticallyCentred && 'vertical-align: middle;';
}, function (props) {
	return props.isHighlighted && '\n\t\t\t\tbackground-color: ' + colours.generalPalette.orangeLighter + ';\n\t\t\t\tfont-family: ' + props.theme.fonts.text.bold + ';\n\t\t\t\t' + useFontSize.of.bute() + '\n\t\t\t';
});

var TableRow = function TableRow(_ref) {
	var children = _ref.children,
	    isVerticallyCentred = _ref.isVerticallyCentred,
	    isHighlighted = _ref.isHighlighted;
	return React.createElement(
		StyledWrapper$4,
		{ isVerticallyCentred: isVerticallyCentred, isHighlighted: isHighlighted },
		children
	);
};

TableRow.propTypes = {
	children: PropTypes.node,
	isVerticallyCentred: PropTypes.bool,
	isHighlighted: PropTypes.bool
};

TableRow.defaultProps = {
	isVerticallyCentred: false,
	isHighlighted: false
};

var main$4 = "AccordionTable.js";
var deprecations$2 = [{
	replacements: {
		name: "GenericAccordion",
		path: "Layout/Content/Accordions"
	}
}];
var packageJson$4 = {
	main: main$4,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$2
};

var _templateObject$a = taggedTemplateLiteral(['\n\t.c-m-transactions-table--branded {\n\t\tborder: 0 !important;\n\t}\n\t.c-m-transactions-table td:before {\n\t\tdisplay: none;\n\t}\n\n\t> div {\n\t\tborder: 0;\n\t}\n\n\ttable {\n\t\ttable-layout: fixed;\n\t}\n\n\ttbody tr:nth-child(even) {\n\t\tbackground-color: ', ' !important;\n\t}\n'], ['\n\t.c-m-transactions-table--branded {\n\t\tborder: 0 !important;\n\t}\n\t.c-m-transactions-table td:before {\n\t\tdisplay: none;\n\t}\n\n\t> div {\n\t\tborder: 0;\n\t}\n\n\ttable {\n\t\ttable-layout: fixed;\n\t}\n\n\ttbody tr:nth-child(even) {\n\t\tbackground-color: ', ' !important;\n\t}\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\tsvg {\n\t\t', ' height: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n'], ['\n\tsvg {\n\t\t', ' height: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\t.c-m-accordion__title {\n\t\tfont-family: ', ';\n\t\t-webkit-font-smoothing: antialiased;\n\t}\n\t.c-m-accordion__content {\n\t\tpadding: 0 !important;\n\t}\n'], ['\n\tcolor: ', ';\n\t.c-m-accordion__title {\n\t\tfont-family: ', ';\n\t\t-webkit-font-smoothing: antialiased;\n\t}\n\t.c-m-accordion__content {\n\t\tpadding: 0 !important;\n\t}\n']),
    _templateObject4$2 = taggedTemplateLiteral([''], ['']),
    _templateObject5$2 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: ', ' 0 0 ', ';\n'], ['\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tpadding: ', ' 0 0 ', ';\n']);

var StyledEntryWrapper = styled('div')(_templateObject$a, function (props) {
	return props.theme.colours.tableAccent;
});

var StyledIconWrapper$1 = styled('div')(_templateObject2$7, function (props) {
	return props.theme.name === 'vm' && 'fill: ' + props.theme.colours.interaction + ';';
}, function (props) {
	return props.isOpen && 'transform: rotate(180deg)';
});

var StyledWrapper$5 = styled('div')(_templateObject3$3, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.theme.fonts.display.bold;
});

var StyledTableLabel = styled('span')(_templateObject4$2);

var StyledButtonGroup = styled('div')(_templateObject5$2, spacing.DOUBLE, spacing.DOUBLE);

var TableEntry = function TableEntry(_ref) {
	var rows = _ref.rows;
	return React.createElement(
		StyledEntryWrapper,
		null,
		React.createElement(
			Table,
			{ isBranded: true, layout: 'transactions' },
			React.createElement(
				TableBody,
				null,
				rows.map(function (_ref2) {
					var id = _ref2.id,
					    label = _ref2.label,
					    value = _ref2.value;
					return React.createElement(
						TableRow,
						{ key: id },
						React.createElement(
							TableBodyData,
							null,
							React.createElement(
								StyledTableLabel,
								null,
								label
							)
						),
						React.createElement(
							TableBodyData,
							null,
							value
						)
					);
				})
			)
		)
	);
};

TableEntry.propTypes = {
	/** Table row data, in the form of an array */
	rows: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		label: PropTypes.string,
		value: PropTypes.string
	}))
};

var AccordionTable = function (_Component) {
	inherits(AccordionTable, _Component);

	function AccordionTable(props) {
		classCallCheck(this, AccordionTable);

		var _this = possibleConstructorReturn(this, (AccordionTable.__proto__ || Object.getPrototypeOf(AccordionTable)).call(this, props));

		var isOpen = props.isOpen;


		_this.state = {
			isOpen: isOpen
		};
		return _this;
	}

	createClass(AccordionTable, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    topButtonGroup = _props.topButtonGroup,
			    rows = _props.rows,
			    theme = _props.theme,
			    title = _props.title;
			var isOpen = this.state.isOpen;


			var collapseHandler = function collapseHandler(onClick) {
				return function () {
					return _this2.setState({
						isOpen: !_this2.state.isOpen
					}, onClick);
				};
			};

			var iconClassNames = classnames('c-m-accordion__control', {
				'c-m-accordion__control--open': isOpen
			});

			var ChevronDownIcon = getChevronDownSolidLarge(theme.name);

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$4, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$5,
					null,
					React.createElement(
						'div',
						{ className: 'c-m-accordion__item' },
						React.createElement(
							'div',
							{
								role: 'button',
								tabIndex: '0',
								className: 'c-m-accordion__header u-faux-block-link',
								onClick: collapseHandler(),
								onKeyUp: collapseHandler()
							},
							React.createElement(
								'div',
								{ className: 'c-m-accordion__title' },
								React.createElement(
									StandardLabel,
									{ isFlush: true },
									React.createElement(
										'span',
										null,
										title
									)
								),
								React.createElement(
									StyledIconWrapper$1,
									{ className: iconClassNames, isOpen: isOpen },
									React.createElement(ChevronDownIcon, null)
								)
							)
						),
						isOpen && React.createElement(
							'div',
							{ className: 'c-m-accordion__body' },
							React.createElement(
								'div',
								{ className: classnames('c-m-accordion__content') },
								topButtonGroup && React.createElement(
									StyledButtonGroup,
									null,
									topButtonGroup
								),
								rows && React.createElement(TableEntry, { rows: rows })
							)
						)
					)
				)
			);
		}
	}]);
	return AccordionTable;
}(Component);

AccordionTable.propTypes = {
	/** Sets the initial open state of the component. */
	isOpen: PropTypes.bool,
	/** An optional button group to be displayed above the table */
	topButtonGroup: PropTypes.element,
	/** Table row data, in the form of an array */
	rows: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		label: PropTypes.string,
		value: PropTypes.string
	})),
	/** The title for the expand/collapse bar */
	title: PropTypes.string.isRequired
};

AccordionTable.defaultProps = {
	isOpen: false
};

var WrappedAccordionTable = withTheme(AccordionTable);

var main$5 = "ContentReveal.js";
var deprecations$3 = [{
	replacements: {
		name: "ContentRevealPanel",
		path: "Layout/Content/Panels"
	}
}];
var packageJson$5 = {
	main: main$5,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$3
};

var _templateObject$b = taggedTemplateLiteral(['\n\t', ';\n\tmargin-bottom: 16px;\n'], ['\n\t', ';\n\tmargin-bottom: 16px;\n']),
    _templateObject2$8 = taggedTemplateLiteral(['\n\talign-items: center;\n\tcolor: ', ';\n\tdisplay: flex;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n'], ['\n\talign-items: center;\n\tcolor: ', ';\n\tdisplay: flex;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\n\tdiv > svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\tpadding-left: 16px;\n'], ['\n\tpadding-left: 16px;\n']),
    _templateObject4$3 = taggedTemplateLiteral(['\n\tborder-left: 4px solid ', ';\n\tborder-bottom-left-radius: ', ';\n\tborder-top-left-radius: ', ';\n\tbox-sizing: border-box;\n\tmargin-left: 4px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding: 0 20px;\n\ttransition: all 0.15s;\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n'], ['\n\tborder-left: 4px solid ', ';\n\tborder-bottom-left-radius: ', ';\n\tborder-top-left-radius: ', ';\n\tbox-sizing: border-box;\n\tmargin-left: 4px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding: 0 20px;\n\ttransition: all 0.15s;\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n']);

var StyledWrapper$6 = styled('div')(_templateObject$b, useFontSize.of.jura);

var StyledHeader = styled('button')(_templateObject2$8, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.expanded && '\n\t\tmargin-bottom: 16px;\n\t\tdiv > svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
});

var StyledHeaderLabel = styled('span')(_templateObject3$4);

var StyledBodyContent$1 = styled('div')(_templateObject4$3, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return props.expanded && '\n\t\tmax-height: 2000px;\n\t\toverflow: visible;\n\t\tpadding: 16px 20px;\n\t';
});

var ContentReveal = function (_Component) {
	inherits(ContentReveal, _Component);

	function ContentReveal(props) {
		classCallCheck(this, ContentReveal);

		var _this = possibleConstructorReturn(this, (ContentReveal.__proto__ || Object.getPrototypeOf(ContentReveal)).call(this, props));

		var _props$isOpen = props.isOpen,
		    isOpen = _props$isOpen === undefined ? false : _props$isOpen;


		_this.state = {
			isOpen: isOpen
		};
		return _this;
	}

	createClass(ContentReveal, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    header = _props.header,
			    theme = _props.theme;
			var isOpen = this.state.isOpen;

			var ariaLabel = header.toLowerCase().replace(/\s+/g, '');
			var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$5, hasCustomMargins: true },
				React.createElement(
					StyledWrapper$6,
					null,
					React.createElement(
						StyledHeader,
						{
							'aria-labelledby': ariaLabel,
							expanded: isOpen,
							onClick: function onClick() {
								return _this2.setState({ isOpen: !isOpen });
							},
							type: 'button'
						},
						React.createElement(TriangleRightLargeIcon, null),
						React.createElement(
							StyledHeaderLabel,
							{ id: ariaLabel },
							header
						)
					),
					React.createElement(
						StyledBodyContent$1,
						{ expanded: isOpen },
						children
					)
				)
			);
		}
	}]);
	return ContentReveal;
}(Component);

ContentReveal.propTypes = {
	/** This makes up the content of the Content Reveal. Typically this will be a block of text-based content. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** The header label which will be used to control the content reveal. */
	header: PropTypes.string.isRequired,
	/** Sets the initial toggle state on the reveal. */
	isOpen: PropTypes.bool
};

ContentReveal.defaultProps = {};

var WrappedContentReveal = withTheme(ContentReveal);

var InternalSlot = function InternalSlot(_ref) {
	var children = _ref.children;
	return React.createElement(
		'div',
		{ className: 'c-m-internal-slot' },
		children
	);
};

InternalSlot.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

var main$6 = "ExpansionPanel.js";
var deprecations$4 = [{
	replacements: [{
		name: "SubformRevealPanel",
		path: "Layout/Content/Panels"
	}, {
		name: "GenericAccordion",
		path: "Layout/Content/Accordions/GenericAccordion"
	}, {
		name: "InformationRevealPanel",
		path: "Layout/Content/Panels"
	}]
}];
var packageJson$6 = {
	main: main$6,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$4
};

var _templateObject$c = taggedTemplateLiteral(['\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n'], ['\n\tsvg {\n\t\tdisplay: block;\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-left: 8px;\n\t\t', ';\n\t\ttransition: transform 0.3s;\n\t\twidth: 24px;\n\t}\n']);

var brandedFill = function brandedFill(props) {
	return props.isDisabled || props.theme.name !== 'vm' ? colours.generalPalette.white : props.theme.colours.interaction;
};

var StyledIconWrapper$2 = styled('span')(_templateObject$c, function (props) {
	return props.isUnbranded ? colours.typography.body : brandedFill;
}, function (props) {
	return props.isOpen && 'transform: rotate(180deg)';
});

var wrapperClasses = function wrapperClasses(className, isDisabled, isOpen) {
	return classnames(className, 'c-m-expansion-panel', {
		'c-m-expansion-panel--is-disabled': isDisabled,
		'c-m-expansion-panel--is-open': isOpen
	});
};

var headerClasses = function headerClasses(isUnbranded) {
	return classnames('c-m-expansion-panel__header', {
		'c-m-expansion-panel__header--unbranded': isUnbranded
	});
};

var iconClasses = function iconClasses(isUnbranded) {
	return classnames('c-m-expansion-panel__icon', {
		'c-m-expansion-panel__icon--unbranded': isUnbranded
	});
};

var contentClasses = function contentClasses(isUnbranded) {
	return classnames('c-m-expansion-panel__content', {
		'c-m-expansion-panel__content-unbranded': isUnbranded
	});
};

var ExpansionPanel = function (_Component) {
	inherits(ExpansionPanel, _Component);

	function ExpansionPanel(props) {
		classCallCheck(this, ExpansionPanel);

		var _this = possibleConstructorReturn(this, (ExpansionPanel.__proto__ || Object.getPrototypeOf(ExpansionPanel)).call(this, props));

		var isOpen = props.isOpen;


		_this.state = {
			isOpen: isOpen
		};

		_this.expandHandler = _this.expandHandler.bind(_this);
		return _this;
	}

	createClass(ExpansionPanel, [{
		key: 'expandHandler',
		value: function expandHandler() {
			this.setState({
				isOpen: !this.state.isOpen
			});
		}
	}, {
		key: 'render',
		value: function render() {
			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    className = _props.className,
			    isUnbranded = _props.isUnbranded,
			    isDisabled = _props.isDisabled,
			    theme = _props.theme,
			    title = _props.title,
			    titleSize = _props.titleSize;
			var isOpen = this.state.isOpen;


			var isTitleAString = typeof title === 'string' || title instanceof String;
			var ChevronDownIcon = getChevronDownSolidLarge(theme.name);

			return React.createElement(
				InternalComponentFrame,
				{ packageJson: packageJson$6, hasCustomMargins: true },
				React.createElement(
					'section',
					{ className: wrapperClasses(className, isDisabled, isOpen) },
					isTitleAString && React.createElement(
						'button',
						{ className: headerClasses(isUnbranded), disabled: isDisabled, onClick: this.expandHandler },
						React.createElement(
							'h4',
							{
								className: 'c-m-expansion-panel__title c-m-expansion-panel__title--' + titleSize,
								id: 'expansion-panel-334455-label'
							},
							title
						),
						React.createElement(
							StyledIconWrapper$2,
							{
								className: iconClasses(isUnbranded),
								isDisabled: isDisabled,
								isOpen: isOpen,
								isUnbranded: isUnbranded
							},
							React.createElement(ChevronDownIcon, null)
						)
					),
					!isTitleAString && React.createElement(
						'button',
						{ className: headerClasses(isUnbranded), disabled: isDisabled, onClick: this.expandHandler },
						React.createElement(
							InternalSlot,
							null,
							title
						),
						React.createElement(
							StyledIconWrapper$2,
							{
								className: iconClasses(isUnbranded),
								isDisabled: isDisabled,
								isOpen: isOpen,
								isUnbranded: isUnbranded
							},
							React.createElement(ChevronDownIcon, null)
						)
					),
					isOpen && React.createElement(
						'div',
						{ className: contentClasses(isUnbranded) },
						React.createElement(
							'div',
							{ className: 'c-m-expansion-panel__body u-rich-text' },
							children
						)
					)
				)
			);
		}
	}]);
	return ExpansionPanel;
}(Component);

ExpansionPanel.propTypes = {
	/** This makes up the content of the expansion panel. Typical use case would be body copy and a button group. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Allows addition of classes (such as utility classes) to the wrapper class. */
	className: PropTypes.string,
	/** Only for initial appearance. */
	isOpen: PropTypes.bool,
	/** If disabled this component is not interactive. */
	isDisabled: PropTypes.bool,
	/** If unbranded the style of the header changes. */
	isUnbranded: PropTypes.bool,
	/** This will dictate the size of the title and subsquently the height of the header. */
	titleSize: PropTypes.oneOf(['lewis', 'skye', 'shetland', 'mull', 'islay', 'orkney', 'arran', 'jura', 'uist', 'bute', 'cumbrae']),
	/** This will appear in the header. */
	title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired
};

ExpansionPanel.defaultProps = {
	isOpen: false,
	titleSize: 'jura'
};

var WrapperExpansionPanel = withTheme(ExpansionPanel);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray_1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return _arrayMap(value, baseToString) + '';
  }
  if (isSymbol_1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _baseToString = baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : _baseToString(value);
}

var toString_1 = toString;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString_1(prefix) + id;
}

var uniqueId_1 = uniqueId;

var _templateObject$d = taggedTemplateLiteral(['\n\tborder: 0;\n\tcolor: ', ';\n\tdisplay: block;\n\tpadding: ', ';\n\t&:before {\n\t\tcontent: ', '\n\t\tdisplay: inline-block;\n\t\tfont-family: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: 100%;\n\t}\n\t@media (min-width: ', ') {\n\t\t&:before {\n\t\t\twidth: 50%;\n\t\t}\n\t}\n\t@media (min-width: ', ') {\n\t\tdisplay: table-cell;\n\t\ttext-align: ', ';\n\t\t&:before {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n'], ['\n\tborder: 0;\n\tcolor: ', ';\n\tdisplay: block;\n\tpadding: ', ';\n\t&:before {\n\t\tcontent: ', '\n\t\tdisplay: inline-block;\n\t\tfont-family: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: 100%;\n\t}\n\t@media (min-width: ', ') {\n\t\t&:before {\n\t\t\twidth: 50%;\n\t\t}\n\t}\n\t@media (min-width: ', ') {\n\t\tdisplay: table-cell;\n\t\ttext-align: ', ';\n\t\t&:before {\n\t\t\tdisplay: none;\n\t\t}\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n']);

var StyledTableCell = styled('td')(_templateObject$d, function (props) {
	return props.theme.colours.bodyText;
}, spacing.SINGLE, function (props) {
	return '"' + props.label + '";';
}, function (props) {
	return props.theme.fonts.display.bold;
}, spacing.SINGLE, breakpoint('xs2'), breakpoint('md1'), function (props) {
	return props.alignment;
});

var ExpansionTableCell = function ExpansionTableCell(_ref) {
	var alignment = _ref.alignment,
	    label = _ref.label,
	    value = _ref.value;
	return React.createElement(
		StyledTableCell,
		{ alignment: alignment, key: uniqueId_1(), label: label },
		value
	);
};

ExpansionTableCell.propTypes = {
	/** Sets the cell text alignment, defaulting to left */
	alignment: PropTypes.oneOf(['center', 'left', 'right']),
	/** You must pass the cell's column header for the responsive layout to display correctly */
	label: PropTypes.string.isRequired,
	/** The cell value */
	value: PropTypes.string.isRequired
};

ExpansionTableCell.defaultProps = {
	alignment: 'left'
};

var _templateObject$e = taggedTemplateLiteral(['\n\tborder: 0;\n\tcolor: ', ';\n\tfont-family: ', ';\n\tpadding: ', ' ', ';\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n'], ['\n\tborder: 0;\n\tcolor: ', ';\n\tfont-family: ', ';\n\tpadding: ', ' ', ';\n\t@media (min-width: ', ') {\n\t\ttext-align: ', ';\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n']);

var StyledTableHeader = styled('th')(_templateObject$e, function (props) {
	return props.theme.colours.bodyText;
}, function (props) {
	return props.theme.fonts.display.bold;
}, spacing.DOUBLE, spacing.SINGLE, breakpoint('md1'), function (props) {
	return props.alignment;
});

var ExpansionTableHeader = function ExpansionTableHeader(_ref) {
	var alignment = _ref.alignment,
	    value = _ref.value;
	return React.createElement(
		StyledTableHeader,
		{ alignment: alignment, key: uniqueId_1() },
		value
	);
};

ExpansionTableHeader.propTypes = {
	/** Sets the text alignment for the header cell, defaulted to left */
	alignment: PropTypes.oneOf(['centre', 'left', 'right']),
	/** The cell value */
	value: PropTypes.string.isRequired
};

ExpansionTableHeader.defaultProps = {
	alignment: 'left'
};

var main$7 = "ExpansionTable.js";
var deprecations$5 = [{
	replacements: {
		name: "ContentRevealPanel",
		path: "Layout/Content/Panels"
	}
}];
var packageJson$7 = {
	main: main$7,
	"component-id": null,
	"component-life-cycle": "deprecated",
	"is-bespoke": false,
	deprecations: deprecations$5
};

var _templateObject$f = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n'], ['\n\tcolor: ', ';\n\tthead {\n\t\tdisplay: none;\n\t\t@media (min-width: ', ') {\n\t\t\tdisplay: table-header-group;\n\t\t}\n\t}\n']),
    _templateObject2$9 = taggedTemplateLiteral(['\n\toverflow-x: auto;\n\tpadding: 0 ', ';\n'], ['\n\toverflow-x: auto;\n\tpadding: 0 ', ';\n']),
    _templateObject3$5 = taggedTemplateLiteral(['\n\twidth: 100%;\n\ttr {\n\t\tborder-bottom: 1px solid ', ';\n\t\tdisplay: block;\n\t\tpadding: ', ' 0;\n\t\t&:first-child {\n\t\t\tpadding-top: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom: 0;\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tborder-bottom: 0;\n\t\t\tdisplay: table-row;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n'], ['\n\twidth: 100%;\n\ttr {\n\t\tborder-bottom: 1px solid ', ';\n\t\tdisplay: block;\n\t\tpadding: ', ' 0;\n\t\t&:first-child {\n\t\t\tpadding-top: 0;\n\t\t}\n\t\t&:last-child {\n\t\t\tborder-bottom: 0;\n\t\t\tpadding-bottom: 0;\n\t\t}\n\t\t@media (min-width: ', ') {\n\t\t\tborder-bottom: 0;\n\t\t\tdisplay: table-row;\n\t\t\tpadding: 0;\n\t\t}\n\t}\n']),
    _templateObject4$4 = taggedTemplateLiteral(['\n\tsvg {\n\t\tfill: ', ';\n\t}\n'], ['\n\tsvg {\n\t\tfill: ', ';\n\t}\n']);

var StyledWrapper$7 = styled('div')(_templateObject$f, function (props) {
	return props.theme.colours.bodyText;
}, breakpoint('md1'));

var StyledContent = styled('div')(_templateObject2$9, spacing.DOUBLE);

var StyledTable$1 = styled('table')(_templateObject3$5, colours.component.border, spacing.SINGLE, breakpoint('md1'));

var StyledExpansionPanel = styled(WrapperExpansionPanel)(_templateObject4$4, function (props) {
	return props.theme.name === 'vm' ? props.theme.colours.interaction : props.theme.colours.bodyText;
});

// eslint-disable-next-line react/prop-types
var ExpansionTable = function ExpansionTable(_ref) {
	var _ref$data = _ref.data,
	    headers = _ref$data.headers,
	    rows = _ref$data.rows,
	    theme = _ref.theme,
	    title = _ref.title;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$7, hasCustomMargins: true },
		React.createElement(
			StyledWrapper$7,
			null,
			React.createElement(
				StyledExpansionPanel,
				{ isUnbranded: theme.name !== 'vm', title: title },
				React.createElement(
					StyledContent,
					null,
					React.createElement(
						StyledTable$1,
						null,
						React.createElement(
							'thead',
							null,
							React.createElement(
								'tr',
								null,
								headers.map(function (_ref2) {
									var _ref2$alignment = _ref2.alignment,
									    alignment = _ref2$alignment === undefined ? 'left' : _ref2$alignment,
									    value = _ref2.value;
									return React.createElement(ExpansionTableHeader, { alignment: alignment, value: value, key: value });
								})
							)
						),
						React.createElement(
							'tbody',
							null,
							rows.map(function (row) {
								return React.createElement(
									'tr',
									{ key: uniqueId_1() },
									row.map(function (_ref3, index) {
										var _ref3$alignment = _ref3.alignment,
										    alignment = _ref3$alignment === undefined ? 'left' : _ref3$alignment,
										    value = _ref3.value;
										return React.createElement(ExpansionTableCell, {
											alignment: alignment,
											key: uniqueId_1(),
											label: headers[index].value,
											value: value
										});
									})
								);
							})
						)
					)
				)
			)
		)
	);
};

ExpansionTable.Cell = {
	date: function date(value) {
		return { alignment: 'left', value: value };
	},
	text: function text(value) {
		return { value: value };
	},
	currency: function currency(value) {
		return { alignment: 'right', value: value };
	},
	option: function option(value) {
		return { alignment: 'right', value: value };
	}
};

ExpansionTable.propTypes = {
	/** Table data object, structured as defined. Alignment is optional, defaulting to 'left' */
	data: PropTypes.shape({
		headers: PropTypes.arrayOf(PropTypes.shape({
			alignment: PropTypes.string,
			value: PropTypes.string
		})),
		rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
			alignment: PropTypes.string,
			value: PropTypes.string
		})))
	}).isRequired,
	/** Title label to be shown in the dropdown toggle bar */
	title: PropTypes.string.isRequired
};

ExpansionTable.defaultProps = {};

var WrappedExpansionTable = withTheme(ExpansionTable);

export { Accordion, WrappedAccordionItem as AccordionItem, WrappedAccordionTable as AccordionTable, WrappedContentReveal as ContentReveal, WrapperExpansionPanel as ExpansionPanel, WrappedExpansionTable as ExpansionTable };
